import { getEnvironmentFromLocation } from './environment-detector.util';
import { CONFIG_ENCRYPTION_KEYS } from './config-encryption-keys';
/**
 * API Gateway endpoint URLs for the secrets/config manager service.
 * These are NOT secrets - they are public API URLs that require Okta authentication.
 * The actual secrets are stored in AWS Secrets Manager and accessed through these endpoints.
 *
 */
const SECRETS_ENDPOINTS = {
    dev: {
        usEast1: 'https://w5d97t8o3g.execute-api.us-east-1.amazonaws.com/dev',
        euWest1: 'https://8htb3o4ps9.execute-api.eu-west-1.amazonaws.com/dev'
    },
    uat: {
        usEast1: 'https://5n8de8a5n0.execute-api.us-east-1.amazonaws.com/uat',
        euWest1: 'https://pgoja9p42g.execute-api.eu-west-1.amazonaws.com/uat'
    },
    qa: {
        usEast1: 'https://5buq1b3ju7.execute-api.us-east-1.amazonaws.com/qa',
        euWest1: 'https://5buq1b3ju7.execute-api.us-east-1.amazonaws.com/qa' // Assuming same for now
    },
    prod: {
        usEast1: 'https://5ibj8hh376.execute-api.us-east-1.amazonaws.com/prod',
        euWest1: 'https://w88of00v20.execute-api.eu-west-1.amazonaws.com/prod' // Assuming same for now
    }
};
/** Returns the config encryption key for the current environment (injected at build time from GitHub Secrets). */
export function getConfigEncryptionKey() {
    const env = getEnvironmentFromLocation();
    const key = CONFIG_ENCRYPTION_KEYS[env];
    if (!key) {
        console.warn(`⚠️ No encryption key configured for environment: ${env}, falling back to dev key`);
        return CONFIG_ENCRYPTION_KEYS['dev'];
    }
    return key;
}
/**
 * Returns the full secrets endpoint URL based on the current environment and region.
 * These URLs are hardcoded per environment - configs are now loaded from Secrets Manager.
 */
export function getSecretsEndpointFullUrl() {
    const env = getEnvironmentFromLocation();
    const isStandby = window.location.href.includes('standby');
    const region = isStandby ? 'euWest1' : 'usEast1'; // Simplified region logic
    const endpoint = SECRETS_ENDPOINTS[env]?.[region];
    if (!endpoint) {
        console.error(`❌ No secrets endpoint found for environment: ${env} and region: ${region}`);
        // Fallback to dev
        return `${SECRETS_ENDPOINTS.dev.usEast1}/feconfigs`;
    }
    return `${endpoint}/feconfigs`;
}
//# sourceMappingURL=secrets-endpoint.util.js.map